import { render, staticRenderFns } from "./admin_czlc.vue?vue&type=template&id=0172495b&scoped=true"
import script from "./admin_czlc.vue?vue&type=script&lang=js"
export * from "./admin_czlc.vue?vue&type=script&lang=js"
import style0 from "./admin_czlc.vue?vue&type=style&index=0&id=0172495b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172495b",
  null
  
)

export default component.exports